import React, { Component } from 'react';
import AWS from 'aws-sdk';
//import {TextInput, SelectInput} from './FormInputs.js';
import './maindefinitions.css';
import './BasicTables.css';
import './SampleCartPage.css';


class SampleCartPage extends Component {

	constructor(props) {
    super(props);
		this.state = {
			sampleCartTable: null,
			fullName: '',
			address: '',
			company: '',
			delivery: 'Sidarta',
			email: this.props.authData.attributes.email
		};

		 this.readInfoPrice = this.readInfoPrice.bind(this);
     this.handleRequestSamples = this.handleRequestSamples.bind(this);
     this.handleRemove = this.handleRemove.bind(this);
		 this.readCartTable = this.readCartTable.bind(this);
		 this.clearCart = this.clearCart.bind(this);
		 this.cartTableToState = this.cartTableToState.bind(this);
		 this.pricesToState = this.pricesToState.bind(this);
		 this.handleChange = this.handleChange.bind(this);
		 this.startEdit = this.startEdit.bind(this);

  }

	handleChange(event) {
    this.setState({[event.target.name]: event.target.value});
  }

	//Trivial solution to redirect to info form. Must change to embed info form
	// on cart page and allow editing without redirect
	startEdit() {
		this.props.history.push('/info');
	}

  componentDidMount() {

    this.props.auth.currentCredentials()
      .then(credentials => {
        const dynamodb = new AWS.DynamoDB.DocumentClient({
          region: 'us-east-1',
          credentials: this.props.auth.essentialCredentials(credentials)
        });

				this.readCartTable(dynamodb);

				var userParams = {
					ExpressionAttributeValues: {
						':id': this.props.authData.attributes.sub,
					},
					ExpressionAttributeNames: {
						'#id': 'userId',
					},
					KeyConditionExpression: '#id = :id' ,
					TableName: 'UserInfo'
				};

				dynamodb.query(userParams, (err, data) => {
					if (err) {
						console.log(err);
						return null;
					} else {
						this.setState(
							data.Items[0]
						);
					}
				});
    })
	  .catch(error => {
		console.log(error);
	});
  }

	readCartTable(dynamodb) {
		var params = {
			ExpressionAttributeValues: {
				':id': this.props.authData.attributes.sub,
			},
			ExpressionAttributeNames: {
				'#id': 'cartId',
			},
			KeyConditionExpression: '#id = :id',
			TableName: 'RoastedCart'
		};
		dynamodb.query(params, (err, data) => {
			if (err) {
				console.log(err);
				return null;
			} else {
				this.cartTableToState(data.Items[0], dynamodb);
			}
		});
	}

	readInfoPrice(dynamodb, keys) {
		var params = {
		  RequestItems: {
		    'RoastedLots': {
		      Keys: keys
					// [
		      //   {
		      //      'id': 'TA-3593b20190401',
					// 		 'roastTime': 1554130800
		      //   },
					// 	{
		      //      'id': 'TA-3593b20190401b',
					// 		 'roastTime': 1554130800
		      //   }
		      // ]
		    }
		  }
		};

// Used arrow function as callback so this wasn't undefined
// binding in constructor didn't work
		dynamodb.batchGet(params, (err, data) => {
		  if (err) {
				console.log('Error on batch get:');
				console.log(err);
			}
		  else {
				this.pricesToState(data.Responses.RoastedLots);
			}
		});
	}

	pricesToState(items) {
		var prices = {};
		items.forEach(element => {
			prices[element.id] = {
				'price': element.price
			};
		});
		//Store sum cartTotal when saving order
		let cartTotal = 0;
		//stringify to deep clone to keep state immutability
		let newCart = JSON.parse(JSON.stringify(this.state.sampleCartTable));
		newCart.forEach(item => {
			item.price = prices[item.id].price;
			cartTotal += item.quantity * prices[item.id].price;
		})
		this.setState({
			sampleCartTable: newCart,
			cartTotal: cartTotal
		});
	}

	cartTableToState(data, dynamodb) {
		if (data) {
			const itemIds = Object.keys(data).filter(col => col !== 'cartId' && !col.endsWith('info'));
			const cartArray = itemIds.map(id => {
				return (
					{
						'id': id,
						'quantity': data[id],
						'price': 0,
						'info': data[id + 'info']
					}
				);
			});
			this.setState({
				sampleCartTable: cartArray
			});
			const keys = itemIds.map(id => {
				return (
					{
						'id': id,
						'roastTime': data[id + 'info'][2]
					}
				);
			});
			this.readInfoPrice(dynamodb, keys);

		} else {
			this.setState({
							sampleCartTable: null,
							cartTotal: 0
			});
		}
	}

	clearCart(dynamodb) {
		var params = {
			Key: {
				'cartId': this.props.authData.attributes.sub
			},
			// ExpressionAttributeValues: {
			// 	':id': this.props.authData.attributes.sub,
			// },
			// ExpressionAttributeNames: {
			// 	'#id': 'sampleCartID',
			// },
			//KeyConditionExpression: '#id = :id' ,
			//ConditionExpression:"info.rating <= :val",
			TableName: 'RoastedCart'
		};
		dynamodb.delete(params, (err, data) => {
			if (err) {
				console.log(err);
				return null;
			} else {
				//Changed this block to redirect to myOrders when placing an order
				//this.readCartTable(dynamodb);
				this.props.history.push('/myorderspage');
			}
		});
	}

	handleChangeQuant(id, newQuant) {
		if (newQuant < 1) {
			this.handleRemove(id);
		} else {
			this.props.auth.currentCredentials()
				.then(credentials => {
					const dynamodb = new AWS.DynamoDB.DocumentClient({
						region: 'us-east-1',
						credentials: this.props.auth.essentialCredentials(credentials)
					});
					var params = {
	          ExpressionAttributeValues: {
							':newQuant': newQuant
						},
	          Key: {
	            'cartId' : this.props.authData.attributes.sub
	          },
	          UpdateExpression: 'SET #item = :newQuant',
	          ExpressionAttributeNames: {
	            '#item': id
	          },
						ReturnValues: 'ALL_NEW',
	          // KeyConditionExpression: '#id = :id' ,
	          TableName: 'RoastedCart'
	        };

					dynamodb.update(params, (err, data) => {
						if (err) {
							console.log(err);
							return null;
						} else {
							//Requerying all tables verytime quant changes.
							// This may be too slow. If so, change code to just update quant
							//  and cart Total
							if (data.Attributes) {
								this.cartTableToState(data.Attributes, dynamodb);
							} else {
								this.setState({
												sampleCartTable: null,
								});
							}
						}
					});
				})
				.catch(error => {
				console.log(error);
			});
		}
	}

	handleRemove(id) {
		this.props.auth.currentCredentials()
			.then(credentials => {
				const dynamodb = new AWS.DynamoDB.DocumentClient({
					region: 'us-east-1',
					credentials: this.props.auth.essentialCredentials(credentials)
				});
				var params = {
          // ExpressionAttributeValues: {
					// 	':i': index
					// },
          Key: {
            'cartId' : this.props.authData.attributes.sub
          },
          UpdateExpression: 'REMOVE #item, #itemInfo',
          ExpressionAttributeNames: {
            '#item': id,
						'#itemInfo': id + 'info'
          },
					ReturnValues: 'ALL_NEW',
          // KeyConditionExpression: '#id = :id' ,
          TableName: 'RoastedCart'
        };

				dynamodb.update(params, (err, data) => {
					if (err) {
						console.log(err);
						return null;
					} else {
						if (data.Attributes) {
							this.cartTableToState(data.Attributes, dynamodb);
						} else {
							this.setState({
											sampleCartTable: null,
							});
						}
					}
				});
			})
			.catch(error => {
			console.log(error);
		});
	}

	handleRequestSamples() {
		//Returns if cart is empty
		if (!this.state.sampleCartTable) {return(false);}

		this.props.auth.currentCredentials()
			.then(credentials => {
				const dynamodb = new AWS.DynamoDB.DocumentClient({
					region: 'us-east-1',
					credentials: this.props.auth.essentialCredentials(credentials)
				});
				var params = {
          // ExpressionAttributeValues: {
					// 	':chosenLots': this.state.sampleCartTable,
					// 	':orderNumber': Math.floor(Date.now() / 1000),
					// 	':userId': this.props.authData.attributes.sub
					// },
          // Key: {
          //   'sampleCartID' : this.props.authData.attributes.sub
          // },
          //UpdateExpression: "REMOVE chosenLots[4]",
          // ExpressionAttributeNames: {
          //   '#items': 'chosenLots',
          // },
          // KeyConditionExpression: '#id = :id' ,
					Item: {
						'userId': this.props.authData.attributes.sub,
						'orderNumber': Date.now(),
						'orderTime': Date.now(),
						'chosenLots': this.state.sampleCartTable,
						'delivery': this.state.delivery,
						'orderStatus': 'Pending',
						'total': this.state.cartTotal
					},
          TableName: 'RoastedOrders'
        };

				dynamodb.put(params, (err, data) => {
					if (err) {
						console.log(err);
						return null;
					} else {
						this.clearCart(dynamodb);
					}
				});
			})
			.catch(error => {
			console.log(error);
		});
	}



  render() {

	var chosenSamples;
		if (this.state.sampleCartTable) {
			chosenSamples = this.state.sampleCartTable.map((doc, index) => {
				var roastDate = new Date(doc.info[2] * 1000);
				return (
					<tr key={index}>
							<td className='pagetitle2'>{doc.info[1]}</td>
              <td> {roastDate.toDateString()}</td>
							<td>
								<i className="material-icons mdGreen mdPointer mdAlign" onClick={() => this.handleChangeQuant(doc.id, doc.quantity + 1)}> add_circle </i>
								{doc.quantity}
                                <i className="material-icons mdGreen mdPointer mdAlign" onClick={() => this.handleChangeQuant(doc.id, doc.quantity - 1)}> remove_circle </i>
							</td>
							<td>R$ {doc.price}</td>
			        <td>R$ {doc.price * doc.quantity}</td>
              <td >
	              <i className="material-icons mdRed mdPointer" onClick={() => this.handleRemove(doc.id)}> clear </i>
              </td>
					</tr>
				);
			});
		} else {
			chosenSamples = <tr><td>I feel so empty! Please, add some coffees!</td></tr>;
		}

	   return (
		   <div >
			<div className='textsnarrow'>
		 		    <p className="pagetitle">Carrinho de compras</p>
	   			    <p className="pagetitle2">1.Verifique os cafés que você escolheu</p>

	   		</div>
            <div className="basic-table-container2">
					    <table className="basic-table">
						    <tbody>
							    <tr>
								    <th>Lote</th>
								    <th>Data da torra</th>
								    <th>Qtd</th>
								    <th>Preço</th>
								    <th>Total por Item</th>
								    <th></th>
							    </tr>
							    {chosenSamples}
							    </tbody>
					    </table>
            </div>
            <div className='textsnarrow row'>
                <p className="pagetitle">Total do carrinho: R$ {this.state.cartTotal ? this.state.cartTotal : ''}</p>
            </div>
            <div className='textsnarrow'>
               <p className="pagetitle2">2.Confirme seus dados e pressione Confirmar ou <a className="linkInText" onClick={this.startEdit}>edite seus dados</a>
			   </p>

               <div className='basicforms form_container2 col-80'>
	   			<div className="confirmInfo_container">
	   				<div className="row">
							<div className="col-25">
								<label>Name</label>
							</div>
							<div className="col-75">
								<input type="text" disabled name="fullName" value={this.state.fullName} onChange={this.handleChange}  />
							</div>
	   				</div>
	   				<div className="row">
	   					<div className="col-25">
								<label>Email</label>
							</div>
							<div className="col-75">
								<input type="email" disabled name="email" value={this.state.email} onChange={this.handleChange}  />
							</div>
	   				</div>
	   				
	   				<div className="row">
	   					<div className="col-25">
								<label>Address</label>
							</div>
							<div className="col-75">
								<input type="text" disabled name="address" value={this.state.address} onChange={this.handleChange}  />
							</div>
	   				</div>
						<div className="row">
	   					<div className="col-25">
								<label>Retirada</label>
							</div>
							<div className="col-75">
								<select name="delivery" value={this.state.delivery} onChange={this.handleChange}>
									<option value='Sidarta'>Sidarta</option>
									{/*<option value='Outro'>Outro</option>*/}
								</select>
							</div>
	   				</div>
	   				<div className="row">
							<div className="col-100">
								<input type="submit" value="Confirmar Pedido" onClick={this.handleRequestSamples}/>
							</div>
	    			</div>
					</div>
	   		</div>
               </div>
		   </div>

    );
  }
}

export default SampleCartPage;
// JavaScript Document



// WEBPACK FOOTER //
// ./src/components/SampleCartPage.js